import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=c87ace26&scoped=true"
import script from "./BaseAddress.vue?vue&type=script&lang=js"
export * from "./BaseAddress.vue?vue&type=script&lang=js"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&id=c87ace26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87ace26",
  null
  
)

export default component.exports